// @flow

import React, { useEffect, useRef, useState } from 'react';
import type { Node } from 'react';
import { VisualSearchCardMenu } from 'shared_components/forms/search/visual/CardMenu';

import {
  visualSearchCardCls,
  visualSearchCardControlsCls,
  visualSearchCardMenuCls,
  visualSearchCardMenuWrapperCls,
} from 'shared_components/forms/search/visual/Visual.less';

type Props = {
  includeMenu: boolean,
  item: Object,
  children: Node | string,
  onBackToResult: Function,
  onMenuClick: Function,
};

/**
 * VisualSearchCard
 *
 * @param {props} Props
 * @returns {Node}
 */
export function VisualSearchCard({
  item,
  children,
  includeMenu,
  onBackToResult,
  onMenuClick,
}: Props): Node {
  const dropdownWrapperRef = useRef(null);
  const [opened, setOpened] = useState(false);

  function handleToggle() {
    onMenuClick(
      !opened
        ? { wrapperElm: dropdownWrapperRef.current, opened: true, onBackToResult, item }
        : null,
    );

    setOpened(!opened);
  }

  useEffect(() => {
    /**
     * handleClickOutside
     *
     * @param {*} event
     */
    function handleClickOutside(event: Event) {
      const className = event && event.target && event.target.className;
      const isDropdownWrapperClicked =
        typeof className === 'string' &&
        className.split(' ').indexOf(visualSearchCardMenuWrapperCls) !== -1;

      if (
        isDropdownWrapperClicked ||
        (!document.querySelector(`.${visualSearchCardMenuCls}`).contains(event.target) &&
          dropdownWrapperRef &&
          dropdownWrapperRef.current &&
          !dropdownWrapperRef.current.contains(event.target))
      ) {
        onMenuClick(null);
        setOpened(false);
      }
    }

    // Remove event listener
    document.removeEventListener('mousedown', handleClickOutside);

    // Add event listener if dropdown is opened
    if (opened) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup after component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [opened, onMenuClick]);

  return (
    <div className={visualSearchCardCls}>
      {children}
      <div className={visualSearchCardMenuWrapperCls} ref={dropdownWrapperRef}>
        <button type="button" className={visualSearchCardControlsCls} onClick={handleToggle}>
          <span>...</span>
        </button>
        {includeMenu ? (
          <VisualSearchCardMenu
            wrapperElm={dropdownWrapperRef.current}
            opened={opened}
            onBackToResult={onBackToResult}
            item={item}
          />
        ) : null}
      </div>
    </div>
  );
}
